const formatter = new Intl.NumberFormat('es-AR', {
  style: 'currency',
  currency: 'ARS',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

/**
 * Formats a number as ARS currency with consistent formatting.
 * e.g. 9317 → "$ 9.317,00", 24623.5 → "$ 24.623,50"
 */
export function formatCurrency(value) {
  return formatter.format(value || 0);
}
